<template>
  <div>
    <div class="text-lg font-bold">
      ข้อมูลผู้สร้างเอกสาร
    </div>
    <div
      class="grid grid-cols-1 lg:grid-cols-4 lg:gap-4 space-y-2 lg:space-y-0 mt-5"
    >
      <div class="w-full">
        <label class="form-label font-bold">ชื่อผู้ขอเบิก:</label>
        <div>{{ reqName }}</div>
      </div>
      <div>
        <label class="form-label font-bold">หน่วยงาน / บริษัท:</label>
        <div>{{ companyName }}</div>
      </div>
      <div>
        <label class="form-label font-bold">รหัสหน่วยงาน:</label>
        <div class="">{{ buNo }} ({{ buName }})</div>
      </div>
      <div>
        <label class="form-label font-bold">เบอร์ติดต่อ:</label>
        <div>{{ telephone }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, toRefs } from 'vue'

export default defineComponent({
  props: {
    reqName: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    companyName: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    buNo: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    buName: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    telephone: {
      type: String,
      default: () => 'ไม่ระบุ'
    }
  },
  setup(props) {
    return {
      ...toRefs(props)
    }
  }
})
</script>

<style scoped></style>
